import { useEffect, useState } from 'react';
import { debounce } from 'lodash';
import { EXPANDER_COLUMN_ID, CAMPAIGN_COLUMN_ID, TOGGLE_COLUMN_ID } from './columns/constants';
var getColumnVisibility = function (windowWidth, columns) {
    var columnVisibility = columns.reduce(function (acc, column) {
        if (windowWidth < 1024) {
            acc[column.id] = [CAMPAIGN_COLUMN_ID, TOGGLE_COLUMN_ID, EXPANDER_COLUMN_ID].includes(column.id);
        }
        else {
            acc[column.id] = column.id !== EXPANDER_COLUMN_ID;
        }
        return acc;
    }, {});
    return columnVisibility;
};
var getHasExpandingColumns = function (columnVisibility) {
    return Object.entries(columnVisibility).some(function (_a) {
        var columnId = _a[0], isVisible = _a[1];
        return columnId !== EXPANDER_COLUMN_ID && !isVisible;
    });
};
export var useResponsiveColumns = function (columns) {
    var _a = useState(getColumnVisibility(window.innerWidth, columns)), columnVisibility = _a[0], setColumnVisibility = _a[1];
    var _b = useState(getHasExpandingColumns(columnVisibility)), hasExpandingColumns = _b[0], setHasExpandingColumns = _b[1];
    useEffect(function () {
        var handleResize = debounce(function () {
            var newColumnVisibility = getColumnVisibility(window.innerWidth, columns);
            setColumnVisibility(newColumnVisibility);
            setHasExpandingColumns(getHasExpandingColumns(newColumnVisibility));
        }, 500);
        window.addEventListener('resize', handleResize);
        return function () {
            window.removeEventListener('resize', handleResize);
        };
    }, [columns]);
    return {
        columnVisibility: columnVisibility,
        hasExpandingColumns: hasExpandingColumns,
    };
};
